// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const BodyRoot = styled.div`
  padding: 2rem;
`;
